import { render, staticRenderFns } from "./InlineTextEdit.vue?vue&type=template&id=12b0a555&scoped=true&"
import script from "./InlineTextEdit.vue?vue&type=script&lang=ts&"
export * from "./InlineTextEdit.vue?vue&type=script&lang=ts&"
import style0 from "./InlineTextEdit.vue?vue&type=style&index=0&id=12b0a555&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0a555",
  null
  
)

export default component.exports